const childRoutes = (prop) => [
    {
        path: 'pending-demand-list',
        name: prop + '.pending_demand_list',
        meta: { auth: true },
        component: () => import('../pages/pending-demand-list/List.vue')
    },
    {
        path: 'distribution-list',
        name: prop + '.distribution_list',
        meta: { auth: true },
        component: () => import('../pages/distribution-list/List.vue')
    },
    {
        path: 'distribution',
        name: prop + '.distribution',
        meta: { auth: true },
        component: () => import('../pages/pending-demand-list/Form.vue'),
        props: true
    },
    {
        path: 'stock-summary-report',
        name: prop + '.stock_summary_report',
        meta: { auth: true },
        component: () => import('../pages/stock-summary-report/List.vue')
    },
    {
        path: 'device-wise-stock-report',
        name: prop + '.device_wise_stock_report',
        meta: { auth: true },
        component: () => import('../pages/device-wise-stock-report/List.vue')
    },
    {
        path: 'purchases-against-distribution-report',
        name: prop + '.purchases_against_distribution_report',
        meta: { auth: true },
        component: () => import('../pages/purchases-against-distribution-report/List.vue')
    },
    {
        path: 'demand-stock-dashboard',
        name: prop + '.demand_stock_dashboard',
        meta: { auth: true },
        component: () => import('../pages/demand-stock-dashboard/Dashboard.vue')
    },
    {
        path: 'distribution-receipt-list',
        name: prop + '.distribution_receipt_list',
        meta: { auth: true },
        component: () => import('../pages/distribution-receipt-list/List.vue')
    },
    {
        path: 'psosk-requisition-list',
        name: prop + '.psosk_requisition_list',
        meta: { auth: true },
        component: () => import('../pages/psosk-requisition/List.vue')
    },
    {
        path: 'psosk-requisition-form',
        name: prop + '.psosk_requisition_form',
        meta: { auth: true },
        component: () => import('../pages/psosk-requisition/Form.vue')
    },
    {
        path: 'psosk-requisition-request',
        name: prop + '.psosk_requisition_request',
        meta: { auth: true },
        component: () => import('../pages/psosk-requisition-request/List.vue')
    },
    {
        path: 'psosk-requsition-transfer',
        name: prop + '.psosk_requsition_transfer',
        meta: { auth: true },
        component: () => import('../pages/psosk-requsition-transfer/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/assistive-device-delivery-and-distribution-management',
    name: 'awareness_event_service.assistive_device_delivery_and_distribution_management',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.assistive_device_delivery_and_distribution_management')
}]

export default routes
